var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel",style:({ width: '100%', height: '600px' })},[_c('el-carousel',{attrs:{"height":"600px"}},_vm._l((_vm.images),function(item,index){return _c('el-carousel-item',{key:index},[_c('img',{staticStyle:{"width":"100%","height":"100%","object-fit":"cover"},attrs:{"src":item}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }